/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Type_PlaceholderInputs */

const en_job_form_type_placeholder = /** @type {(inputs: Job_Form_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Internship, Full-time`)
};

const de_job_form_type_placeholder = /** @type {(inputs: Job_Form_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Praktikum, Vollzeit`)
};

/**
* | output |
* | --- |
* | "e.g. Internship, Full-time" |
*
* @param {Job_Form_Type_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_type_placeholder = /** @type {((inputs?: Job_Form_Type_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Type_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_type_placeholder(inputs)
	return en_job_form_type_placeholder(inputs)
});